import React, { useRef } from "react";
import html2pdf from "html2pdf.js";
import TransactionReceipt from "./TransactionReceipt";
import "../../Styles/receipt-download.scss";

const HTMLtoPDFGenerator = ({ data }) => {
  const receiptRef = useRef(null);

  const generatePDF = () => {
    const content = receiptRef.current;
    if (!content) return;

    const options = {
      margin: [6, 6, 6, 6],
      filename: "transaction-receipt.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        scrollX: 0,
        scrollY: 0,
        useCORS: true,
        windowWidth: content.scrollWidth,
      },
      pagebreak: {
        mode: ["css", "legacy"],
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf().from(content).set(options).save();
  };

  return (
    <>
      <div className="new-receipt-template-wrapper" aria-hidden="true">
        <TransactionReceipt data={data} innerRef={receiptRef} />
      </div>
      <button
        type="button"
        className="new-receipt-download"
        onClick={generatePDF}
        disabled={!data}
      >
        <span>Download Receipt</span>
      </button>
    </>
  );
};

export default HTMLtoPDFGenerator;
